import type { DocMigration } from "../docMigration";

/** Inline snapshot matching built-in masonry defaults — migration stays isolated from app defaults. */
const builtinMasonryComponentsMerged = {
  ["cmu-4"]: {
    entityType: "MASONRY_COMPONENT",
    id: "cmu-4",
    name: '4" CMU',
    masonryType: "CONCRETE",
    profile: "CMU_4",
    sortIndex: 0,
  },
  ["cmu-6"]: {
    entityType: "MASONRY_COMPONENT",
    id: "cmu-6",
    name: '6" CMU',
    masonryType: "CONCRETE",
    profile: "CMU_6",
    sortIndex: 1,
  },
  ["cmu-8"]: {
    entityType: "MASONRY_COMPONENT",
    id: "cmu-8",
    name: '8" CMU',
    masonryType: "CONCRETE",
    profile: "CMU_8",
    sortIndex: 2,
  },
  ["cmu-10"]: {
    entityType: "MASONRY_COMPONENT",
    id: "cmu-10",
    name: '10" CMU',
    masonryType: "CONCRETE",
    profile: "CMU_10",
    sortIndex: 3,
  },
  ["cmu-12"]: {
    entityType: "MASONRY_COMPONENT",
    id: "cmu-12",
    name: '12" CMU',
    masonryType: "CONCRETE",
    profile: "CMU_12",
    sortIndex: 4,
  },
};

const migration: DocMigration = {
  id: "20260512_add_masonry_components_doc_table",
  description: "Adds masonryComponents root table with built-in CMU entries when missing",
  apply(json: any, _warnings: string[], _errors: string[]): any {
    const existing =
      json.masonryComponents !== undefined &&
      json.masonryComponents !== null &&
      typeof json.masonryComponents === "object"
        ? json.masonryComponents
        : {};
    json.masonryComponents = {
      ...builtinMasonryComponentsMerged,
      ...existing,
    };
    return json;
  },
};

export default migration;
